import React from 'react';
import styles from './user-profile-section-heading.scss';

interface UserProfileSectionHeadingProps {
  sectionTitle: string;
  disclaimer?: string;
}

export const UserProfileSectionHeading = ({ sectionTitle, disclaimer }: UserProfileSectionHeadingProps) => sectionTitle
  ? <div className={`main-grid ${styles.sectionHeading}`}>
    <h2>{sectionTitle}</h2>
    {disclaimer && <p>{disclaimer}</p>}
  </div>
  : null;
